
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { getAmountDistributionList } from "@/api/customer";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "CreateClaim",
})
export default class extends Vue {
  @Prop({ default: "0" }) private hqPackingListId: "";
  @Prop({ default: "0" }) private supplierId: "";
  @Prop({ default: "" }) private status: string;
  @Prop({ default: true }) private getButtonTrue: boolean;
  @Prop({ default: [] }) private amountDistributionList: [];
  private form = {
    customerId: null,
    company: null,
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public tableCol = [
    {
      label: "采购订单号",
      prop: "purchaseOrderCode",
      key: "purchaseOrderCode",
      show: true,
      disabled: false,
    },
    {
      label: "付款单号",
      prop: "paymentVoucherCode",
      key: "paymentVoucherCode",
      show: true,
      disabled: false,
    },
    {
      label: "付款性质",
      prop: "paymentType",
      key: "paymentType",
      show: true,
      disabled: false,
    },
    {
      label: "付款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false,
    },
    {
      label: "已分配金额",
      prop: "assignedAmount",
      key: "assignedAmount",
      show: true,
      disabled: false,
    },
    {
      label: "本次分配",
      prop: "useAmount",
      key: "useAmount",
      show: true,
      disabled: false,
      type: "inputNumber",
      precision: 2,
      maxProp: "canAssignedAmount",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 100,
    },
  ] as any;

  private get tableColumns() {
    return this.canUpdate ? this.tableCol : this.tableCol.filter((item) => item.key !== "actions");
  }

  @Watch("amountDistributionList", { immediate: true })
  private watchType() {
    this.table.list = deepClone(this.amountDistributionList)
  }

  private get canUpdate() {
    return this.status !== '在库'
        && this.status !== '部分出库'
        && this.status !== '出库待处置'
        && this.status !== '完全出库'
        && this.getButtonTrue;
  }

  //  删除
  public async handleDelete(scope) {
    this.table.list.splice(scope.$index, 1);
  }
  public loading: Boolean = false;
  private async handleAdd() {
    this.loading = true;
    let params = {
      hqPackingListId: this.hqPackingListId,
    };
    await getAmountDistributionList(params).then((res:any) => {
      this.table.list = deepClone(this.amountDistributionList)
      this.table.list = [...this.table.list,...res];
      this.loading = false;
    }).catch(err => {
      console.log(err);
      this.loading = false;
    });
  }
  public async inputchange({ val, row, column }) {
    if (column.key === "useAmount") {
      let params = {
        hqPackingListId: this.hqPackingListId,
        supplierId: this.supplierId,
      };
      let data = [
        {
          useAmount: parseInt(val),
          paymentVoucherId: row.row.paymentVoucherId,
        },
      ];
      this.$emit("updateUseAmount", { params, data });
    }
  }

  public getAmount() {
    return this.table.list.reduce((acc, cur) => acc + cur.useAmount, 0);
  }
}
